export default __webpack_public_path__ + "static/seniorfelicitation-f8d6556be3e973c06a11c2bbf5ef6ff9.png";